import { render, staticRenderFns } from "./binding_clients.vue?vue&type=template&id=a0ae5ca6&scoped=true&"
import script from "./binding_clients.vue?vue&type=script&lang=ts&"
export * from "./binding_clients.vue?vue&type=script&lang=ts&"
import style0 from "./binding_clients.vue?vue&type=style&index=0&id=a0ae5ca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae5ca6",
  null
  
)

export default component.exports